import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Popover } from 'antd';

import noop from 'lodash/noop';

import { isSupervisorUser } from 'Auth/redux/auth.redux';

import s from './style/Sidebar.pcss';


@connect(
  state => ({
    isSupervisor: isSupervisorUser(state),
  }),
)
export default class TreeNode extends React.Component {
  static propTypes = {
    node: PropTypes.shape().isRequired,
    isSelected: PropTypes.bool.isRequired,
    onRemove: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    isSupervisor: PropTypes.bool.isRequired,
  };

  state = {
    popoverVisible: false,
    isDeleting: false,
  };

  setPopoverVisible = popoverVisible => this.setState({ popoverVisible });

  onRoleRemove = () => this.setState({ isDeleting: true }, () => {
    this.props.onRemove(this.props.node.id)
      .then(() => this.setState({ isDeleting: false, popoverVisible: false }));
  });

  onEdit = () => this.setState({ popoverVisible: false }, this.props.onEdit);

  renderPopoverContent = () => (
    <div className={s.popoverContent}>
      <div className={s.popoverItem} onClick={this.onEdit}>
        Редактировать
      </div>
      {!this.props.isSupervisor &&
        <div
          className={`${s.popoverItem} ${this.state.isDeleting ? s.disabled : ''}`}
          onClick={this.state.isDeleting ? noop : this.onRoleRemove}
        >
          Удалить
        </div>
      }
    </div>
  );

  prevent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    const { node, isSelected } = this.props;
    const { popoverVisible } = this.state;
    const style = {};
    if (node.weightIndex === 0) {
      style.fontSize = 18;
      style.color = '#202124';
      style.fontWeight = isSelected ? 'bold' : 400;
    }
    return (
      <div className={s.nodeContainer}>
        <div className={`${s.nodeName} ${node.isLocked ? s.lockedNode : ''}`} style={style}>{node.name}</div>
        {node.isLocked &&
          <div className={s.lockedIcon} />
        }
        {!node.isLocked &&
          <div className={`${s.popoverContainer} ${popoverVisible ? s.shown : ''}`} onClick={this.prevent}>
            <Popover
              placement="bottomRight"
              trigger="click"
              onVisibleChange={this.setPopoverVisible}
              visible={popoverVisible}
              title={null}
              arrowPointAtCenter
              content={this.renderPopoverContent()}
            >
              <Icon type="ellipsis" />
            </Popover>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Sections/Sidebar/TreeNode.js